export default __webpack_public_path__ + "static/ross-bateman-77d06f8c6fa301e7bf377fb03e247017.png";